import React from 'react';
import { useNavigate } from 'react-router-dom';
import './products.css';
import mining from "../../assets/mining.png";
import rubber from "../../assets/rubber.png";
import logistics from "../../assets/logistics.png";
import coldstorage from "../../assets/cold-storage.png"; 

const Products = () => {
  const industries = [
    { name: "Crushers and Mining", image: mining },
    { name: "Rubber", image: rubber },
    { name: "Logistics and Transportation", image: logistics },
    { name: "Cold Storage Plants", image: coldstorage },
  ];

  const navigate = useNavigate();

  return (
    <div className="products-container">
      <h2 className="products-title">Our Product Catalogue</h2>
      <p className="products-description">
        We are in various industries with over 90 products. Explore our diverse range of products designed to meet the needs of different sectors, providing top-quality oils and lubricants.
      </p>
      <div className="products-grid">
        {industries.map((industry, index) => (
          <div key={index} className="product-card" onClick={() => navigate(`/industry-products/${industry.name}`)}>
            <img src={industry.image} alt={industry.name} className="product-image" />
            <div className="product-name">{industry.name}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Products;
